var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34388 8.98373C1.38747 11.0274 1.40926 12.0493 2.16334 12.8062C2.91743 13.5632 3.96693 13.5895 6.06593 13.6423C7.35958 13.6748 8.64051 13.6748 9.93418 13.6423C12.0332 13.5895 13.0826 13.5632 13.8367 12.8062C14.5908 12.0493 14.6126 11.0274 14.6562 8.98373C14.6702 8.3266 14.6702 7.67333 14.6562 7.01627C14.6126 4.97255 14.5908 3.95071 13.8367 3.19375C13.0826 2.4368 12.0332 2.41043 9.93418 2.35769C8.64051 2.32519 7.35958 2.32519 6.06592 2.35769C3.96693 2.41042 2.91743 2.43679 2.16334 3.19375C1.40926 3.9507 1.38746 4.97255 1.34388 7.0162C1.32987 7.67333 1.32987 8.3266 1.34388 8.98373Z",
    fill: "white",
    stroke: "#8790A1",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 5.66667L6.62797 6.82627C7.77143 7.50234 8.22849 7.50234 9.37196 6.82627L11.3333 5.66667",
    stroke: "#8790A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIc);
export default __webpack_public_path__ + "static/media/email_ic.f93fad52c9c4104a101e12fb047a902a.svg";
export { ForwardRef as ReactComponent };